import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, Check, ChevronRight } from "lucide-react";
import "./AccountSelector.css";

function AccountSelector({ accounts, selectedAccountId, onSelect, onManageAccount }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedAccount = accounts.find((acc) => acc.id === selectedAccountId);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleSelect = (accountId) => {
    onSelect(accountId);
    setIsOpen(false);
  };

  if (accounts.length === 0) {
    return null;
  }

  return (
    <div className="account-selector-wrapper" ref={dropdownRef}>
      {/* Main Button */}
      <button
        className="account-selector-button"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        <span className="account-selector-label">
          {selectedAccount?.name || "Select Account"}
        </span>
        <ChevronDown
          size={16}
          className={`account-selector-chevron ${isOpen ? "open" : ""}`}
        />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="account-selector-dropdown">
          <div className="account-selector-list">
            {accounts.map((account) => (
              <button
                key={account.id}
                className={`account-selector-item ${
                  account.id === selectedAccountId ? "selected" : ""
                }`}
                onClick={() => handleSelect(account.id)}
                type="button"
              >
                <span className="account-selector-item-name">{account.name}</span>
                {account.id === selectedAccountId && (
                  <Check size={16} className="account-selector-check" />
                )}
              </button>
            ))}
          </div>

          {/* Manage Account Option */}
          <div className="account-selector-divider"></div>
          <button
            className="account-selector-manage"
            onClick={() => {
              setIsOpen(false);
              if (onManageAccount) {
                onManageAccount();
              }
            }}
            type="button"
          >
            <span>Manage account</span>
            <ChevronRight size={16} />
          </button>
        </div>
      )}
    </div>
  );
}

export default AccountSelector;
